import { render, staticRenderFns } from "./SimpleVideo.vue?vue&type=template&id=00b009e4&scoped=true&"
import script from "./SimpleVideo.vue?vue&type=script&lang=js&"
export * from "./SimpleVideo.vue?vue&type=script&lang=js&"
import style0 from "./SimpleVideo.vue?vue&type=style&index=0&id=00b009e4&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b009e4",
  null
  
)

export default component.exports